export default {
  "build": 60,
  "version": "0.8",
  "date": "8/26/2024, 8:01:13 PM",
  "time": 1724727673548
};